module.exports = __webpack_public_path__ + "static/OH-b35c105838326755a0bdc2ca81bacd8f.svg";